import React, { useMemo } from 'react';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import { useUser } from 'global/UserContext';
import { useIframeCommunication } from 'hooks/useIframeCommunication';
import { buildThemeParams } from 'microfrontends/config/theme';
import { API_URLS } from 'utils/apiUrlBuilder';

('use client');

const IframeContainer: React.FC = () => {
  const { user } = useUser();
  const userId = user?.id;
  const theme = useThemeContext();

  const themeParams = useMemo(() => buildThemeParams(theme), [theme]);

  const getOrganizationUuid = () => {
    try {
      const orgUuid = localStorage.getItem('x-organization-uuid');
      if (!orgUuid) {
        console.warn('Organization UUID not found in localStorage');
        return '';
      }
      return orgUuid;
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };

  const baseUrl = useMemo(() => {
    const orgUuid = getOrganizationUuid();
    return `${API_URLS.ADVISOR_PLATFORM}/calls/schedule?organization_uuid=${orgUuid}&userId=${userId}`;
  }, [userId]);

  const iframeUrl = useMemo(() => `${baseUrl}&${themeParams}`, [baseUrl, themeParams]);

  const { iframeRef } = useIframeCommunication(iframeUrl);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        style={{
          flex: 1,
          minHeight: '1000px',
          border: 'none',
        }}
        width="100%"
        title="Scheduled Calls - NextJS"
      />
    </div>
  );
};

export default IframeContainer;
